import { Link } from "@tanstack/react-router";
import { Phone, MessageSquare, Mail, ClipboardList } from "lucide-react";
import { trackPartsFunnel } from "@/lib/parts-funnel";

/** Snabbaste vägen in: ring, sms:a eller mejla en bild — formuläret finns kvar för den som vill. */
export function QuickPartContact({ label }: { label: string }) {
  const body = encodeURIComponent(
    `Hej! Jag söker en reservdel (${label}). Bild bifogad. Chassinummer/årsmodell: `,
  );
  const btn =
    "inline-flex min-h-11 items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-medium transition";
  return (
    <div className="mt-6 rounded-3xl border border-border bg-card p-5">
      <p className="font-display text-lg">Snabbast: skicka en bild direkt</p>
      <p className="mt-1 text-sm text-muted-foreground">
        Ta en bild på delen och skicka med chassinummer eller årsmodell — så får du pris inom 24 h.
      </p>
      <div className="mt-4 grid gap-2 sm:grid-cols-2">
        <a href="tel:0708629743" onClick={() => trackPartsFunnel("quick_call", false)} className={`${btn} bg-primary text-primary-foreground hover:bg-primary/90`}>
          <Phone className="h-4 w-4" /> Ring 070-862 97 43
        </a>
        <a href={`sms:0708629743?&body=${body}`} onClick={() => trackPartsFunnel("quick_sms", false)} className={`${btn} border border-border hover:bg-secondary`}>
          <MessageSquare className="h-4 w-4" /> Sms:a en bild
        </a>
        <a href={`mailto:reservdelar@akhusbilfritid.se?subject=${encodeURIComponent(`Reservdel: ${label}`)}&body=${body}`} onClick={() => trackPartsFunnel("quick_mail", false)} className={`${btn} border border-border hover:bg-secondary`}>
          <Mail className="h-4 w-4" /> Mejla en bild
        </a>
        <Link to="/reservdelar" hash="reservdel-form" className={`${btn} border border-border hover:bg-secondary`}>
          <ClipboardList className="h-4 w-4" /> Fyll i formuläret
        </Link>
      </div>
    </div>
  );
}
